//  export const M_GET_LEARNING_INFO = "M_GET_LEARNING_INFO";
export const M_SET_IS_BOOKING_NO_REGISTRATION = "M_SET_IS_BOOKING_NO_REGISTRATION";
export const M_SET_IS_SETTINGS_NO_REGISTRATION = "M_SET_IS_SETTINGS_NO_REGISTRATION";